import Dashboard from "../assets/images/icon/data-governance.png";
import Team from "../assets/images/icon/group.png";
import deposit from "../assets/images/icon/wallet-in.png";
import Withdraw from "../assets/images/icon/wallet-out.png";
import purchasing from "../assets/images/icon/purchasing.png";
import verified from "../assets/images/icon/verified.png";
import profile from "../assets/images/icon/profile.png";
import bank from "../assets/images/icon/bank.png";
import settings from "../assets/images/icon/settings.png";
import cashier from "../assets/images/icon/cashier.png";
import approved from "../assets/images/icon/wallet-in-count.png";
import report from "../assets/images/icon/data-analysis.png";
import invoice from "../assets/images/icon/invoice.png";
import ticket from "../assets/images/icon/ticket.png";
import check from "../assets/images/icon/check.png";
import { Avatar } from "antd";

export const FilterClassNameIcon = (i) => {
  if (i === "/dashboard") {
    return <Avatar shape="square" size={24} src={Dashboard} />;
  } else if (i === "/bank-bank-customer") {
    return <Avatar shape="square" size={24} src={Team} />;
  } else if (i === "/verify-customer") {
    return <Avatar shape="square" size={24} src={check} />;
  } else if (i === "/deposit-transaction" || i === "/feePayIn") {
    return <Avatar shape="square" size={24} src={deposit} />;
  } else if (i === "/withdraw-transaction" || i === "/feePayOut") {
    return <Avatar shape="square" size={24} src={Withdraw} />;
  } else if (
    i === "/bank-account" ||
    i === "/client-transfer" ||
    i === "/statement"
  ) {
    return <Avatar shape="square" size={24} src={bank} />;
  } else if (i === "/manage-merchant") {
    return <Avatar shape="square" size={24} src={cashier} />;
  } else if (
    i === "/verifyslip-transactions"
  ) {
    return <Avatar shape="square" size={24} src={verified} />;
  }
  // ******************
  else if (i === "/user" || i === "/role" || i === "/user-activity") {
    return <Avatar shape="square" size={24} src={profile} />;
  } else if (i === "/chart-report") {
    return <Avatar shape="square" size={24} src={report} />;
  } else if (i === "/setting") {
    return <Avatar shape="square" size={24} src={settings} />;
  } else if (i === "/top-up-approval") {
    return <Avatar shape="square" size={24} src={approved} />;
  } else if (i === "/buyCredit") {
    return <Avatar shape="square" size={24} src={purchasing} />;
  } else if (i === "/invoices" || i === "/manage-invoices") {
    return <Avatar shape="square" size={24} src={invoice} />;
  } else if (i === "/pending-ticket" || i === "/all-ticket") {
    return <Avatar shape="square" size={24} src={ticket} />;
  }  else {
    return null;
  }
};
